// extracted by mini-css-extract-plugin
export default {"price":"_4-z","onSale":"a5-z","msrpLabelPrice":"b5-z","msrpLabel":"c5-z","originalPrice":"d5-z","percentOff":"e5-z"};